import { AccountHoldingFragment } from 'graphql/bindings/AdminBindings'
import { InfoCardProps } from '@forgeglobal/design-framework'
import { Routes } from 'util/Routes'
import { formatAbbreviatedMoney, formatAbbreviatedNumber } from 'util/NumberUtils'
import { getGravatarUrl } from 'util/GravatarUtil'

export enum LinkTo {
  Issuer,
  Account,
}

export const transformHoldingFragment = (
  holding: AccountHoldingFragment,
  issuer: boolean = false,
  linkTo: LinkTo = LinkTo.Account
): InfoCardProps => {
  let shareType
  if (holding.type === 'stock_option_grant') {
    shareType = 'options'
  } else if (holding.type === 'rsu_grant') {
    shareType = 'RSUs'
  } else {
    shareType = 'shares'
  }

  let numShares
  if (holding.confirmed_num_shares) {
    numShares = `${formatAbbreviatedNumber(holding.confirmed_num_shares)} ${shareType}`
  } else if (holding.estimated_num_shares) {
    numShares = `~ ${formatAbbreviatedNumber(holding.estimated_num_shares)} ${shareType}`
  } else {
    numShares = ''
  }
  const account = holding?.account
  const gravatarUrl = getGravatarUrl(account?.email ?? '')
  const holdingValue = holding.current_value || holding.share_dollar_amt_est
  const holdingData: InfoCardProps = {
    logo: issuer ? gravatarUrl : holding.company.logo_url,
    leftTitle: issuer ? account?.name ?? '' : holding.company.name,
    rightTitle: holding.current_value ? formatAbbreviatedMoney(holdingValue) : holdingValue,
    leftSubtitle: holding.share_class || '',
    rightSubtitle: numShares,
    link: linkTo === LinkTo.Account ? Routes.account(account?.id ?? '') : Routes.issuer(holding.company.crm_account.id),
  }
  return holdingData
}
